// extracted by mini-css-extract-plugin
module.exports = {"links-row":"footer-links_links-row__lRqjy","category":"footer-links_category__7Xnux","links":"footer-links_links__AnBAJ","link-item":"footer-links_link-item__N62C6"};